module.exports = __webpack_public_path__ + "static/media/Dashboard1.a24efb9b.svg";